var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedback-success"},[_c('navbar',{attrs:{"title":"意见反馈","left-text":"","show-home":""}}),_c('img',{attrs:{"src":require("../assets/img/feedback-suc-tips.png"),"alt":""}}),_c('p',[_vm._v("感谢您的反馈，我们会尽快处理。")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }